import z from "zod"

export const BigBlueWebhookEventTypeEnum = {
  UrlVerification: "URL_VERIFICATION",
} as const

export const BigBlueWebhookParamsSchema = z.object({
  companySlug: z.string().min(1),
})

export const BigBlueUrlVerificationWebhookSchema = z.object({
  challenge: z.string().min(1),
})

export const BigBlueOrderStatusWebhookSchema = z.object({
  update_time: z.string(),
  order_status: z.object({
    id: z.string().min(1),
    external_id: z.string(),
    carrier: z.string().optional(),
    code: z.string(),
    tracking_number: z.string().optional(),
    tracking_url: z.string().optional(),
  }),
})
